import { Map } from 'immutable';
/**
 * Server state
 *
 * @export
 * @class ServerState
 */
var ServerState = /** @class */ (function () {
    function ServerState() {
        /**
         * The list of posts server
         * @memberof ServerState
         */
        this.request = Map({});
    }
    return ServerState;
}());
export { ServerState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/server/ServerState.ts
// module id = 579
// module chunks = 50